import InputField from "./InputField";
import Icons from "../../../../../components/icons";

const SourceTab = ({ onChangeSource, onForceRefresh, currentSource }) => {
  return (
    <div className="my-7 flex items-center gap-4 border !border-border rounded-sm px-5 py-4">
      <h1 className="text-md font-semibold mr-3">Current Source</h1>
      <InputField
        classNames="!bg-muted focus:!border-border"
        disabled
        value={currentSource?.website_url || currentSource?.file_name || "form"}
      />
      <div className="flex items-center gap-3 ml-2">
        <button
          className="border !border-border px-3 py-2.5 rounded-md"
          onClick={onForceRefresh}
        >
          <Icons id={"refreshIcon"} />
          <span className="ml-2 text-destructive">Force Refresh</span>
        </button>
        <button
          className="border !border-border px-3 py-2.5 rounded-md"
          onClick={onChangeSource}
        >
          <Icons id={"uploadRedIcon"} />
          <span className="ml-2 text-destructive">Change Source</span>
        </button>
      </div>
    </div>
  );
};

export default SourceTab;
